export default {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  '301': '该用户未注册! ',
  '302': '账号或密码错误！',

  '303': '该企业已过期! ',
  '305': '您的账户已冻结!',

  '2008':'验证码错误!',
  'default': '系统错误！'
}



// WEBPACK FOOTER //
// ./src/request/errorCode.js